import React from "react";
import Pizza from "../images/commercialheader.jpg"

const Commercial = (props) => {
    return (
        <div>
            <h1> Commercial and Restaurants</h1>
            <img src={Pizza} class="img-fluid mb-3" />
            <p>Whether you are a mass merchant retailer, a restaurant, a hotel, or an industrial user, Brookline Firewood is the superior firewood sales supplier for your needs. Reliability is a must for all our wholesale customers; at Brookline Firewood we fulfill orders promptly and can fill all types of custom order needs. Pricing is based on consumption and is proportionate to the quantity ordered.
                In most commercial kitchens, temperature consistency and speed of food output is key. With our Kiln-dried firewood, you can always expect the same low-water content that guarantees the consistent temperatures that will improve your culinary output.</p>

        </div>
    )
};
export default Commercial;